import { useCallback, useMemo, useState } from "react";
import { endpoints } from "../../config";
import useAjaxRequest, { GET } from "../requests/useAjaxRequest";

export const RESULTADO_MENSAL = "RESULTADO_MENSAL";
export const RESULTADO_ANUAL = "RESULTADO_ANUAL";

const useMapaPremios = () => {
  const [{ ano, mes }, setParametrosBusca] = useState({ ano: "", mes: "" });

  const {
    response: { error: errorRequestAnual, data: dataAnual },
    loading: loadingAnual,
    performRequest: performRequestPremiosAnuais,
  } = useAjaxRequest();

  const {
    response: { error: errorRequestMensal, data: dataMensal },
    loading: loadingMensal,
    performRequest: performRequestPremiosMensais,
  } = useAjaxRequest();

  const loading = useMemo(() => loadingAnual || loadingMensal, [
    loadingAnual,
    loadingMensal,
  ]);

  const errors = useMemo(
    () =>
      errorRequestAnual || errorRequestMensal
        ? { ...errorRequestAnual, ...errorRequestMensal }
        : null,
    [errorRequestAnual, errorRequestMensal]
  );

  const transformResult = useCallback((data) => {
    return (Array.isArray(data) ? data : []).reduce(
      (
        ...[
          { qdtTitulos, valorPremio },
          { valorPremio: valorPremioRegional, qdtTitulos: qdtTitulosRegional },
          ,
          regionais,
        ]
      ) => ({
        regionais,
        qdtTitulos: qdtTitulos + qdtTitulosRegional,
        valorPremio: valorPremio + valorPremioRegional,
      }),
      { regionais: [], qdtTitulos: 0, valorPremio: 0 }
    );
  }, []);

  const resultadoMensal = useMemo(() => transformResult(dataMensal), [
    dataMensal,
    transformResult,
  ]);
  const resultadoAnual = useMemo(() => transformResult(dataAnual), [
    dataAnual,
    transformResult,
  ]);

  const performRequest = useCallback(async (params, callback) => {
    const options = {
      method: GET,
      url: endpoints.getMapPremios(params),
    };
    return callback(options);
  }, []);

  const getResultadoAnual = useCallback(
    async (params) => {
      return performRequest({ ...params, mes: 0 }, performRequestPremiosAnuais);
    },
    [performRequest, performRequestPremiosAnuais]
  );

  const getResultadoMensal = useCallback(
    async (params) => {
      const { ano: anoBusca, mes: mesBusca } = { ...params };
      await setParametrosBusca((current) => ({ ...current, ...params }));

      if (anoBusca !== ano) {
        getResultadoAnual(params);
      }

      if (mesBusca !== mes) {
        performRequest(params, performRequestPremiosMensais);
      }
    },
    [ano, getResultadoAnual, mes, performRequest, performRequestPremiosMensais]
  );

  const tipoBusca = useCallback((params) => {
    const { mesBusca } = { ...params };
    return mesBusca === "0" ? RESULTADO_ANUAL : RESULTADO_MENSAL;
  }, []);

  return {
    ano,
    mes,
    loading,
    errors,
    getResultadoMensal,
    getResultadoAnual,
    resultadoAnual,
    resultadoMensal,
    tipoBusca,
  };
};

export default useMapaPremios;
